import { render, staticRenderFns } from "./ProgressChart.vue?vue&type=template&id=6a2ec4be&scoped=true"
import script from "./ProgressChart.vue?vue&type=script&lang=js"
export * from "./ProgressChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ec4be",
  null
  
)

export default component.exports